import api from './api';

// Get active announcements (public - no auth required)
export const getActiveAnnouncements = async () => {
    const response = await api.get('/announcements/active');
    return response.data;
};

// Get all announcements (admin/hod/receptionist)
export const getAllAnnouncements = async (params = {}) => {
    const response = await api.get('/announcements', { params });
    return response.data;
};

// Get single announcement by ID
export const getAnnouncementById = async (id) => {
    const response = await api.get(`/announcements/${id}`);
    return response.data;
};

// Create new announcement (supports file upload)
export const createAnnouncement = async (formData) => {
    const response = await api.post('/announcements', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

// Update announcement (supports file upload)
export const updateAnnouncement = async (id, formData) => {
    const response = await api.put(`/announcements/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

// Delete announcement
export const deleteAnnouncement = async (id) => {
    const response = await api.delete(`/announcements/${id}`);
    return response.data;
};

// Toggle announcement status
export const toggleAnnouncementStatus = async (id) => {
    const response = await api.patch(`/announcements/${id}/toggle`);
    return response.data;
};

// Helper function to get the image source URL
export const getAnnouncementImageUrl = (announcement) => {
    if (!announcement) return null;

    if (announcement.imageSrc) {
        // If imageSrc virtual is available
        if (announcement.imageType === 'url') {
            return announcement.imageUrl;
        }
        if (announcement.imageType === 'file') {
            return `${process.env.REACT_APP_API_URL?.replace('/api/v1', '')}${announcement.imageSrc}`;
        }
    }

    // Fallback logic
    if (announcement.imageType === 'url' && announcement.imageUrl) {
        return announcement.imageUrl;
    }
    if (announcement.imageType === 'file' && announcement.imageFile) {
        return `${process.env.REACT_APP_API_URL?.replace('/api/v1', '')}/uploads/announcements/${announcement.imageFile}`;
    }

    return null;
};

export default {
    getActiveAnnouncements,
    getAllAnnouncements,
    getAnnouncementById,
    createAnnouncement,
    updateAnnouncement,
    deleteAnnouncement,
    toggleAnnouncementStatus,
    getAnnouncementImageUrl
};
